export default {

  SET_ADDRESS(state, payload) {
    state.address = {...state.address, ...payload}
  },
  RESET_ADDRESS(state) {
    state.address = {
      full_name: "",
      phone_number: "",
      company_name: "",
      address_line1: "",
      address_line2: "",
      city: "",
      state_or_region: "",
      postal_code: "",
      country_code: "US",
      billingDifferent: false
    }
  },
  SET_PAYMENT_INFO(state, payload) {
    state.payment_info = {...state.payment_info, ...payload}
  },
  RESET_PAYMENT_INFO(state) {
    state.payment_info = {}
  },
  SET_CONTACT(state, payload) {
    state.contact = {...state.contact, ...payload}
  },
  RESET_CONTACT(state) {
    state.contact = {}
  },
  SET_BILLING_ADDRESS(state, payload) {
    state.billing_address = {...state.billing_address, ...payload}
  },
  RESET_BILLING_ADDRESS(state) {
    state.billing_address = {
      full_name: "",
      phone_number: "",
      company_name: "",
      address_line1: "",
      address_line2: "",
      city: "",
      state_or_region: "",
      postal_code: "",
      country_code: "US"
    }
  },
  SET_ITEM_ACCEPTED(state, payload) {
    state.hasAcceptedItems = payload
  },
  SET_ANY_ACCEPTED(state, payload) {
    state.hasAnyAccepted = payload
  },
  SET_CHECKOUT_SETTINGS(state, payload) {
    state.checkout_settings = {...state.checkout_settings, ...payload}
  },
  SET_TOTAL_ORDER(state, payload) {
    state.total_order = payload
  }
}